import { useEffect, useState } from 'react';
import { ListItem, OrderedList } from '@chakra-ui/react';

import { Modal } from 'shared-components';
import { IRecordedInterviewQuestion } from 'api-paths-cas';

import { getMyInterviewAPIKey } from '../../../../utilities/envVariables';

export interface IProps {
  questions: IRecordedInterviewQuestion[];
  hashTimestamp: number;
  hash: string;
  videoId: string;
  onClose: () => void;
}

const RecordedInterviewModal = (props: IProps) => {
  const { questions, hashTimestamp, hash, videoId, onClose } = props;
  const [apiKey, setApiKey] = useState('');
  const params = new URLSearchParams();

  useEffect(() => {
    (async () => {
      const myInterviewApiKey = await getMyInterviewAPIKey();
      const [_, key] = myInterviewApiKey.split(' ');
      setApiKey(key);
    })();
  }, []);

  params.append('hashTimestamp', String(hashTimestamp));
  params.append('hash', hash);
  params.append('video', videoId);
  params.append('autoplay', '0');
  params.append('fs', '1');
  params.append('apiKey', apiKey);

  return (
    <Modal
      id="recorded-interview-modal"
      show
      title={'Watch Recorded Video Interview'}
      onClose={onClose}
      size="2xl"
      hideFooter
    >
      {apiKey && (
        <>
          <iframe
            title="interview"
            width={608}
            height={360}
            src={`https://share.myinterview.com/player?${params.toString()}`}
            allowFullScreen
          />

          <OrderedList pl={0}>
            {questions.map(({ question }, i) => (
              <ListItem key={i}>{question}</ListItem>
            ))}
          </OrderedList>
        </>
      )}
    </Modal>
  );
};

export default RecordedInterviewModal;
